export default __webpack_public_path__ + "static/media/addButton.9fe95d99.svg";